import {
  Caption,
  DocumentIcon,
  ImageIcon,
  mq,
  theme,
  UserIcon,
} from '@kvdbil/components';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useMatch } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.ul`
  height: 5rem;
  box-sizing: border-box;
  padding: 0.2rem 1rem 2rem 1rem;
  margin: auto 0 0 0;
  list-style: none;
  background-color: ${theme.colors.grayscaleToned.light6};

  ${mq('laptop')} {
    padding: 1rem;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: auto;
`;

const StyledLink = styled(Link)<{ $isActive: boolean }>`
  padding: 0.25rem 1.5rem;
  font-size: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  color: ${({ $isActive: isActive }) =>
    isActive ? theme.colors.info.main : theme.colors.text.disabled};

  p {
    margin: 0;
  }

  svg {
    font-size: 1.5rem;
    margin-bottom: 0.1rem;
  }
`;

interface FooterItemProps {
  to: string;
  children: ReactNode;
}
const FooterItem = ({ to, children }: FooterItemProps) => {
  const match = useMatch(`/${to}/*`);
  const isActive = Boolean(match);

  return (
    <li>
      <StyledLink to={to} $isActive={isActive}>
        {children}
      </StyledLink>
    </li>
  );
};

const Footer = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <ButtonContainer>
        <FooterItem to="/items">
          <ImageIcon />
          <Caption>{t('Image upload')}</Caption>
        </FooterItem>
        <FooterItem to="/delivery-receipt">
          <DocumentIcon />
          <Caption>{t('Delivery receipt')}</Caption>
        </FooterItem>
        <FooterItem to="/account">
          <UserIcon />
          <Caption>{t('Account')}</Caption>
        </FooterItem>
      </ButtonContainer>
    </Container>
  );
};

export default Footer;
